(function(){
  var LABEL='Legg i handlekurv';
  function relabel(root){(root||document).querySelectorAll('.fp-form .fp-btn').forEach(function(b){if(!b.dataset.fpL){b.dataset.fpL='1';b.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 7h14l-1.5 12h-11z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><span>'+LABEL+'</span>';}});}
  function toast(msg){var t=document.getElementById('fp-toast');if(!t){t=document.createElement('div');t.id='fp-toast';t.setAttribute('role','status');document.body.appendChild(t);}t.innerHTML=msg;t.className='is-on';clearTimeout(t._h);t._h=setTimeout(function(){t.className='';},4000);}
  async function refreshDrawer(){
    try{
      var html=await (await fetch(location.pathname+location.search,{credentials:'same-origin'})).text();
      var d=new DOMParser().parseFromString(html,'text/html');
      var nIn=d.querySelector('cart-drawer-component .cart-drawer__inner'),oIn=document.querySelector('cart-drawer-component .cart-drawer__inner');
      if(nIn&&oIn){oIn.innerHTML=nIn.innerHTML;}
      var nDlg=d.querySelector('cart-drawer-component dialog'),oDlg=document.querySelector('cart-drawer-component dialog');
      if(nDlg&&oDlg){oDlg.className=nDlg.className;}
      var nB=d.querySelector('.fp-hdr cart-icon'),oB=document.querySelector('.fp-hdr cart-icon');
      if(nB&&oB){oB.innerHTML=nB.innerHTML;oB.className=nB.className;}
      return !!(nIn&&oIn);
    }catch(e){return false;}
  }
  document.addEventListener('submit',async function(e){
    var f=e.target;if(!f.classList||!f.classList.contains('fp-form'))return;
    e.preventDefault();
    var b=f.querySelector('.fp-btn');var old=b?b.innerHTML:'';
    if(b){b.disabled=true;b.innerHTML='<span>Legger til…</span>';}
    try{
      var r=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)});
      var j=await r.json();
      if(!r.ok){toast(j.description||'Vi har dessverre ikke flere av denne på lager.');if(b){b.innerHTML=old;b.disabled=false;}return;}
      if(b){b.innerHTML='<span>Lagt til ✓</span>';b.classList.add('is-added');}
      var ok=await refreshDrawer();
      var cd=document.querySelector('cart-drawer-component');
      if(ok&&cd&&typeof cd.open==='function'){cd.open();}else{toast('<b>Lagt i handlekurven</b><a href="/cart">Til handlekurven</a>');}
      setTimeout(function(){if(b){b.innerHTML=old;b.disabled=false;b.classList.remove('is-added');}},1800);
    }catch(err){f.submit();}
  },true);
  if(document.readyState!=='loading')relabel();else document.addEventListener('DOMContentLoaded',function(){relabel();});
})();
